import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { texts, images } from '../../settings';
import { Actions } from '../../flux';
import { Zoom, Fade } from 'react-reveal/';
import { DelayLink } from '../../components';
//Components
import { Hero } from '../../components/Hero';
import { CardTab } from '../../components/CardTab';

// Templates
import { MercadoCapitais } from './templates/mercado-capitais';
import { Poupanca } from './templates/poupanca';
import { Etica } from './templates/etica';
import { Inovacao } from './templates/inovacao';
import { Tributacao } from './templates/tributacao';
import './PlanoAcao2019.scss';

class PlanoAcao2019 extends Component {
  constructor(props) {
    super(props);
    this.texts = texts;
    this.images = images;
    this.scroll = React.createRef();
    this.state = {
      tabAtiva: 'null',
    };
  }

  scrollTop = () => {
    window.scrollTo({ top: 0 });
  };

  saibaMais = selecionado => {
    console.log('Saiba Mais');
    this.setState({
      tabAtiva: selecionado,
    });
    this.scroll.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render() {
    return (
      <div className="views views--plano-acao-2019">
        <Helmet>
          <title>{this.texts.title}</title>
        </Helmet>

        <div className="pa2019 page-gradient page-gradient--green bg-gray" ref="pa2019">
          <section className="pa2019-area governanca-header page-gradient__header">
            <div className="container">
              <div className="row">
                <div className="col-6">
                  <Fade bottom>
                    <div className="page-header">
                      <h1 className="page-header__title gri_text gri_text--fixed">
                        Resultados do plano de ação 2019
                        <span class="gri_label">
                          GRI <b>102-21, 103-1, 103-2, 103-3, 203-1, 203-2</b>
                        </span>
                      </h1>
                      <p className="page-header__description">
                        No segundo semestre de cada ano, elaboramos um plano de ação que orienta nosso trabalho para
                        todo o ano seguinte. Ele é construído a partir de discussões com os associados, o mercado e a
                        Diretoria e leva em conta as tendências dos mercados brasileiro e internacional.
                        <br />
                        <br />
                        Em 2019, os focos foram o desenvolvimento do mercado de capitais e a modernização da indústria
                        de fundos de investimento. Para isso, escolhemos cinco temas: mercado de capitais, poupança de
                        longo prazo, ética e regulação, inovação e tributação. Cada um contava com objetivos
                        estratégicos a serem alcançados por meio de uma série de iniciativas. A maioria delas foi
                        trabalhada pelos organismos de representação e outras, pela equipe interna.
                      </p>
                    </div>
                  </Fade>
                </div>

                <div className="col-6 col-image">
                  <img src={images.plano_acao_2019.hero_imagem} class="hero_mobile" />

                  <img src={images.plano_acao_2019.braco_homem} class="braco_homem img_desk" />
                  <img src={images.plano_acao_2019.ilustra} class="ilustra img_desk" />
                  <img src={images.plano_acao_2019.lines} class="lines img_desk" />
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* <Hero
          estilo="heroDefault"
          titulo="<span class='gri_text gri_text--fixed'>Resultados do plano de ação 2019 <span class='gri_label'>GRI <b>102-21, 103-1, 103-2, 103-3, 203-1, 203-2</b></span><span>"
          subtitulo="
            <p>No segundo semestre de cada ano, elaboramos um plano de ação que orienta nosso trabalho para todo o ano seguinte. Ele é construído a partir de discussões com os associados, o mercado e a Diretoria e leva em conta as tendências dos mercados brasileiro e internacional.</p>
            <p>Em 2019, os focos foram o desenvolvimento do mercado de capitais e a modernização da indústria de fundos de investimento. Para isso, escolhemos cinco temas: mercado de capitais, poupança de longo prazo, ética e regulação, inovação e tributação. Cada um contava com objetivos estratégicos a serem alcançados por meio de uma série de iniciativas.  A maioria delas foi trabalhada pelos organismos de representação e outras, pela equipe interna.</p>
          "
          imagem={images.plano_acao_2019.hero_imagem}
          background={images.bgs.bg_green}
        /> */}
        <Zoom>
          <h3 className="titulo-outline">Confira o resumo das atividades</h3>
        </Zoom>
        <Fade left>
          <div className="container plano-tabs" ref={this.scroll}>
            <CardTab
              saibaMais={this.saibaMais.bind(this)}
              seleciona="mercado-capitais"
              cor="green"
              titulo="Mercado de capitais"
              selecionado={this.state.tabAtiva}
            />
            <CardTab
              saibaMais={this.saibaMais.bind(this)}
              seleciona="poupanca"
              cor="light-green"
              titulo="Poupança de longo prazo"
              selecionado={this.state.tabAtiva}
            />
            <CardTab
              saibaMais={this.saibaMais.bind(this)}
              seleciona="etica"
              cor="light-blue"
              titulo="Ética e regulação"
              selecionado={this.state.tabAtiva}
            />
            <CardTab
              saibaMais={this.saibaMais.bind(this)}
              seleciona="inovacao"
              cor="blue"
              titulo="Inovação"
              selecionado={this.state.tabAtiva}
            />
            <CardTab
              saibaMais={this.saibaMais.bind(this)}
              seleciona="tributacao"
              cor="yellow"
              titulo="Tributação"
              selecionado={this.state.tabAtiva}
            />
          </div>
        </Fade>
        <div className="container conteudo-tab">
          {this.state.tabAtiva == 'mercado-capitais' && <MercadoCapitais cor="#78BC42" />}
          {this.state.tabAtiva == 'poupanca' && <Poupanca cor="#D1DC35" />}
          {this.state.tabAtiva == 'etica' && <Etica cor="#39B9C4" />}
          {this.state.tabAtiva == 'inovacao' && <Inovacao cor="#0F91D4" />}
          {this.state.tabAtiva == 'tributacao' && <Tributacao cor="#FEAF00" />}
        </div>
        <Fade bottom>
          <div className="container box-footer">
            <div className="row">
              <div className="col-12">
                <Fade>
                  <div className="box-pill box-pill--blue box-pill--center">
                    <div className="box-pill__content box-pill__content--full">
                      <div className="row">
                        <div className="col col-9 col--text col--text--end">
                          <h4>Confira as nossas relações institucionais</h4>
                          <DelayLink
                            to="/relacionamentos"
                            className="button button--aylen button--white-to-blue button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Saiba mais
                          </DelayLink>
                        </div>
                        <div className="col col-3 col--image">
                          <img
                            src={images.relacionamentos.pessoas_topo}
                            className="pessoa_destaque pessoa_destaque--1"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </Fade>
      </div>
    );
  }
}
export { PlanoAcao2019 };
